//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Stack,
  Text,
} from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { OverlayRouter, OverlayWrapper } from "../../components/OverlayRouter";
import { useMedia } from "../../components/ui-elements/SizeDetector";
import Icon from "../../components/ui-elements/Icon";

type TutorExistContentProps = {
  isLoading: boolean;
  teachersRequested: any;
  foundNoResult: any;
  onSubmit: any;
  [key: string]: any;
};

const TutorExistContent: React.FC<TutorExistContentProps> = observer(
  ({
    isLoading,
    teachersRequested = 3,
    foundNoResult = false,
    onSubmit,
    ...rest
  }) => {
    return (
      <Box py={8} px={[0, 3]} {...rest}>
        <Stack spacing={8}>
          <Icon size={10} color="orange.500" name="notification" />
          <Stack fontSize="lg">
            <Text fontSize="2xl" fontWeight="semibold">
              {foundNoResult ? "No tutors were found" : "We found some tutors"}
            </Text>
            {foundNoResult ? (
              <Text opacity={0.8}>
                We've just done a quick search, and regret to inform you that we
                couldn't find available tutors for your request at the moment.
              </Text>
            ) : (
              <Text opacity={0.8}>
                But we didn't find all {teachersRequested} options. Please
                proceed to select from the options we found.
              </Text>
            )}

            {foundNoResult ? (
              <Text opacity={0.8}>
                But not to worry, we're on it. We'll ensure to get back to you
                as soon as possible.
              </Text>
            ) : (
              <Text opacity={0.8}>
                We'll ensure to get back to you as soon as possible.
              </Text>
            )}
          </Stack>
          <Button
            mt={3}
            isLoading={isLoading}
            loadingText="Saving"
            size="lg"
            colorScheme="blue"
            rightIcon={!foundNoResult && <ChevronRightIcon />}
            onClick={() => {
              onSubmit();
            }}
          >
            {foundNoResult ? "Okay, that's fine" : "Proceed"}
          </Button>
        </Stack>
      </Box>
    );
  }
);

type TutorExistsModalProps = {
  isOpen?: boolean;
  onClose?: any;
  isLoading: boolean;
  onSubmit: any;
  teachersRequested: any;
  foundNoResult: any;
};

export const TutorExistsModal: React.FC<TutorExistsModalProps> = observer(
  ({ isOpen, isLoading, onSubmit, teachersRequested, foundNoResult }) => {
    const isMobile = useMedia("(max-width: 420px)");
    const onClose = () => {};
    if (isMobile) {
      return (
        <OverlayWrapper path="/modal">
          <Drawer
            onClose={onClose}
            closeOnOverlayClick={false}
            placement="bottom"
            closeOnEsc={false}
            size="full"
            isOpen={isOpen}
          >
            <DrawerOverlay />
            <DrawerContent borderRadius="8px 8px 0 0" overflow="hidden">
              <DrawerBody>
                <TutorExistContent
                  {...{ teachersRequested, foundNoResult }}
                  isLoading={isLoading}
                  onSubmit={onSubmit}
                />
              </DrawerBody>
            </DrawerContent>
          </Drawer>
        </OverlayWrapper>
      );
    }

    return (
      <OverlayWrapper path="/modal">
        <Modal
          onClose={onClose}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          size="md"
          isOpen={isOpen}
        >
          <ModalOverlay />
          <ModalContent top="3.5rem" rounded="fbRadius" overflow="hidden">
            <ModalBody>
              <TutorExistContent
                {...{ teachersRequested, foundNoResult }}
                isLoading={isLoading}
                onSubmit={onSubmit}
              />
            </ModalBody>
          </ModalContent>
        </Modal>
      </OverlayWrapper>
    );
  }
);

type TutorExistWrapperProps = {
  isLoading: boolean;
  onSubmit: any;
  teachersRequested: any;
  foundNoResult: any;
};

export const TutorExistWrapper: React.FC<TutorExistWrapperProps> = observer(
  ({ isLoading, onSubmit, teachersRequested, foundNoResult }) => {
    return (
      <OverlayRouter>
        <TutorExistsModal
          {...{ teachersRequested, foundNoResult }}
          isLoading={isLoading}
          onSubmit={onSubmit}
        />
      </OverlayRouter>
    );
  }
);

type AdminEditDrawerProps = {
  children: React.ReactNode;
  size: string;
  isOpen: boolean;
  onClose: any;
  closeOnOverlayClick?: boolean;
};

export const AdminEditDrawer: React.FC<AdminEditDrawerProps> = observer(
  ({ children, size = "lg", isOpen, onClose, closeOnOverlayClick = false }) => {
    return (
      <Drawer
        closeOnOverlayClick={closeOnOverlayClick}
        placement="right"
        closeOnEsc={false}
        size={size}
        isOpen={isOpen}
        onClose={onClose}
      >
        <DrawerOverlay />
        <DrawerContent borderRadius="8px 8px 0 0" overflow="hidden">
          <DrawerCloseButton />
          <DrawerHeader />
          <DrawerBody>{children}</DrawerBody>
        </DrawerContent>
      </Drawer>
    );
  }
);
